import React from "react";
import SubTitle from "../../components/common/SubTitle";
import TitleBar from "../../components/navbar/TitleBar";
import { Box } from "@mui/material";
import Footer from "../../components/common/Footer";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import Reports from "../../components/reports/Reports";

export default function SchoolReports() {
  //   const organization = localStorage.getItem("userState") || "Organization";
  //   const orgName = JSON.parse(organization).organization.name;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      {" "}
      <Box>
        <TitleBar />
        <SchoolBusNavMenu />
        <Reports school />
      </Box>
      <Footer />
    </Box>
  );
}
